export default __webpack_public_path__ + "static/media/imageTum13.0e38ab5d.jpg";